import moment from 'moment';

const createCycles = ({
  isSmacAdmin, result, res, customer, sensors, tZones,
}) => {
  const cycles = [];
  const alertCycle = {};
  const dailyStats = {};
  res.forEach(({ data: dS }) => {
    dS.forEach((dailyStat) => {
      const {
        deltaT,
        deltaTInfo,
        uid,
        localDate,
      } = dailyStat;
      const delta = {
        cool: 0,
        heat: 0,
      };
      if (deltaT) {
        delta.cool += deltaT.cool;
        delta.heat += deltaT.heat;
      } else if (deltaTInfo) {
        delta.cool += deltaTInfo.avgDeltaT;
      }
      const uId = uid.split('-')[0];
      if (!dailyStats[uId]) {
        dailyStats[uId] = {
          [localDate]: delta,
        };
      } else {
        dailyStats[uId][localDate] = delta;
      }
    });
  });
  result.forEach(({ data: cD }, idx) => {
    cD.forEach((cycle) => {
      const c = cycle;
      const uId = cycle.uid;
      const sensor = sensors.find((s) => s.uId === c.uid
          && c.supplyAir && s.dId === c.supplyAir.deviceId);
      if (sensor) {
        c.location = sensor.location;
      }
      const zone = customer.devices[idx]
        && customer.devices[idx].deviceAC
        && customer.devices[idx].deviceAC.zone;

      c.zone = zone;
      // SET CYCLE ALERT TO SHOW AS URGENT
      if (alertCycle[`${cycle.startTime}${cycle.endTime}`]) {
        c.alerts = alertCycle[`${cycle.startTime}${cycle.endTime}`];
        alertCycle[`${cycle.startTime}${cycle.endTime}`].cycle = c;
      } else {
        c.alerts = [];
      }
      if (cycle.deltaTs) {
        // GETTING HIGHEST DELTA T TO IGNORE AFTER
        let highest = -1;
        let highestIndex = -1;
        for (let i = 0; i < cycle.deltaTs.length; i += 1) {
          const dT = cycle.deltaTs[i];
          if (dT.deltaTs) {
            if (i > 0 && dT.runned - cycle.deltaTs[i - 1].runned > 300) {
              c.deltaTs = [
                ...c.deltaTs.slice(0, i),
                {
                  deltaTs: [],
                },
                ...c.deltaTs.slice(i),
              ];
            } else if (Math.abs(Math.round(dT.deltaTs[0].deltaT)) > highest) {
              highest = Math.abs(Math.round(dT.deltaTs[0].deltaT));
              highestIndex = i;
            } else if (highest - Math.abs(Math.round(dT.deltaTs[0].deltaT)) >= 2) {
              c.deltaTs = c.deltaTs.slice(0, i);
              break;
            }
          }
        }
        c.highestDeltaT = highest;
        c.highestDeltaTIndex = highestIndex;
      }
      const cycleDate = moment(c.startTime).format('YYYY-MM-DD');
      if (dailyStats[uId] && dailyStats[uId][cycleDate]) {
        c.dailyStat = dailyStats[uId][cycleDate];
      }
      c.startDate = moment(c.startTime).format('MM/DD/YYYY');
      if (c.supplyAir?.deviceId?.includes('-')) {
        const thermostat = tZones.find((z) => z.serialNumber === c.supplyAir.deviceId);
        c.tZone = thermostat && thermostat.zone;
      } else if (c.supplyAir.deviceId) {
        const cn = `${c.uid}-${c.supplyAir.deviceId}`;
        const thermostat = tZones.find((z) => z.serialNumber === cn);
        c.tZone = thermostat && thermostat.zone;
      }

      if (!isSmacAdmin && c.valid) {
        cycles.push(c);
      } else if (isSmacAdmin) {
        cycles.push(c);
      }
    });
  });

  return cycles;
};

export default createCycles;
